import {
  ButtonProps,
  color,
  PrimaryText,
  SecondaryButton,
  useColorMode,
} from 'deepstash-ui';
import React, { useMemo } from 'react';
import { TRANSITION_TIME } from 'utils/constants';
import commonStrings from 'utils/strings/commonStrings';

interface FollowDummyButtonV2Props {
  isFollowed: boolean;
  onClickHandler: React.MouseEventHandler<HTMLButtonElement> | undefined;
  isDisabled: boolean;
  buttonBackgroundColor?: string;
  title?: string;
}

export const FollowDummyButtonV2: React.FC<
  FollowDummyButtonV2Props & ButtonProps
> = ({
  isDisabled,
  isFollowed,
  onClickHandler,
  size,
  buttonBackgroundColor,
  title,
  id,
  ...props
}) => {
  const { colorMode } = useColorMode();

  const followText = useMemo(() => {
    if (title) {
      return title;
    }
    return isFollowed
      ? commonStrings.following.toUpperCase()
      : commonStrings.follow.toUpperCase();
  }, [isFollowed, title]);

  return (
    <SecondaryButton
      colorMode={colorMode}
      size={size}
      bgColor={buttonBackgroundColor}
      borderColor={color[colorMode].text}
      _active={undefined}
      onClick={onClickHandler}
      disabled={isDisabled}
      id={id}
      shadow={undefined}
      transition={`all ${TRANSITION_TIME}s ease-in-out`}
      color={color[colorMode].text}
      _hover={{
        backgroundColor: color[colorMode].text,
        color: color[colorMode].textInverted,
      }}
      {...props}
    >
      <PrimaryText
        type="bold"
        w="max-content"
        size={size === 'lg' ? 'l' : 's'}
        id={id ? `${id}-text` : undefined}
      >
        {followText}
      </PrimaryText>
    </SecondaryButton>
  );
};
